import { GridContainer } from '@bob/library'
import { calcBgAndFontColor } from '@websrc/App/Helpers/calcBgAndFontColor'
import { spotWrapperProps } from '@websrc/App/Helpers/spotWrapperProps'
import { mapCampaignSpot } from '@websrc/DataMappers/mapSpot'
import { SpotCampaignContentProps } from '@websrc/Spot/Campaign/Components/SpotCampaignContent'
import React from 'react'

import { LearnMoreButtonType } from '../Collapse/SpotCollapse'
import { SpotCampaignDesktop } from './Components/SpotCampaignDesktop'
import { SpotCampaignMobile } from './Components/SpotCampaignMobile'

export interface SpotCampaignProps {
  spot: ReturnType<typeof mapCampaignSpot>['campaign_spot']
  LearnMoreButton?: LearnMoreButtonType
  imageLazy?: boolean
  isTopOfPage?: boolean
}

// AKA Hero Spot
export const SpotCampaign: React.FC<SpotCampaignProps> = ({
  spot,
  imageLazy,
  LearnMoreButton,
  isTopOfPage,
}) => {
  const { is_background_image, background_color, asset, settings, caption } = spot
  const hasVideo = Boolean(asset?.video)
  const { bgColor, fontColor } = calcBgAndFontColor(background_color ?? 'Gray')
  const hasBackgroundImage = Boolean(is_background_image && asset?.thumbnail?.url)
  const isReverse = settings.image_on_the_left

  const allProps: SpotCampaignContentProps = {
    bgColor,
    isReverse,
    hasVideo,
    hasBackgroundImage,
    fontColor,
    spot,
    imageLazy,
    LearnMoreButton,
    isTopOfPage,
  }

  return (
    <div data-testid={'caption'} {...spotWrapperProps(caption)}>
      <GridContainer>
        <SpotCampaignDesktop {...allProps} />
        <SpotCampaignMobile {...allProps} />
      </GridContainer>
    </div>
  )
}
